export const moderationPostNotificationTimeout = 6000;
export const moderationAcceptedNotificationTimeout = 8000;
